import { render, staticRenderFns } from "./ActivityItemModal.vue?vue&type=template&id=130c6278"
import script from "./ActivityItemModal.vue?vue&type=script&lang=js"
export * from "./ActivityItemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports